'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookLoma = require('@narvar/nth-hook-loma');
var Asset = require('./Asset.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const BlockAssetWrapper = ({
  featureName,
  featureId,
  fixedPanelHeight,
  localeLanguage,
  localeCountry,
  templateRenderingContext
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const {
    assets
  } = nthHookSettings.useSettings();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const {
    [featureId]: assetFeature
  } = assets || {};
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const {
    assetId = ''
  } = assetFeature || {};
  const client = nthHookLoma.useLomaClient();
  const {
    data: {
      getMarketingAsset: asset = null
    } = {}
  } = nthHookLoma.useGetMarketingAssetQuery({
    client,
    variables: {
      id: assetId,
      language: localeLanguage,
      country: localeCountry
    },
    skip: !assetId
  });
  if (!assetId || !asset) return null;
  return /*#__PURE__*/React__default["default"].createElement(Asset["default"], {
    featureName: featureName,
    assetId: assetId,
    asset: asset,
    fixedPanelHeight: fixedPanelHeight,
    templateRenderingContext: templateRenderingContext
  });
};
var index = nthHookSettings.withSettingsProvider(BlockAssetWrapper, {
  settingsRequested: 'assets'
});

exports["default"] = index;
